// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SiteWrapper_SiteWrap__rRTK2{padding:0 100px}@media only screen and (max-width: 1280px){.SiteWrapper_SiteWrap__rRTK2{padding:0 20px}}`, "",{"version":3,"sources":["webpack://./src/components/SiteWrapper/SiteWrapper.module.scss"],"names":[],"mappings":"AAAA,6BACI,eAAA,CAGJ,2CACI,6BACI,cAAA,CAAA","sourcesContent":[".SiteWrap{padding:0 100px}@media only screen and (max-width: 1280px){.SiteWrap{padding:0 20px}}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SiteWrap": `SiteWrapper_SiteWrap__rRTK2`
};
export default ___CSS_LOADER_EXPORT___;
